const RecoveryPage = () => {
  return <div>RecoveryPage</div>;
};

export default RecoveryPage;
